import { IJwtTokenResponse, IJwtTokenWithApiKeyResponse } from 'multirpc-sdk';

import { JWT } from '../types';
import { decodeJWT } from './decodeJWT';
import { isPrimaryJWTIndex } from './isPrimaryJWTIndex';

export interface IDecodeJWTsProps {
  hasGroupSelected: boolean;
  jwts: Array<IJwtTokenResponse | IJwtTokenWithApiKeyResponse>;
  primaryUserEndpointToken?: string;
}

export const decodeJWTs = async ({
  hasGroupSelected,
  jwts,
  primaryUserEndpointToken,
}: IDecodeJWTsProps) => {
  const promises = jwts.map<Promise<JWT>>(async jwt => {
    const {
      description,
      index,
      is_encrypted: isEncrypted,
      jwt_data: token,
      name,
    } = jwt;

    if (
      !hasGroupSelected &&
      isPrimaryJWTIndex(index) &&
      primaryUserEndpointToken
    ) {
      return {
        description,
        index,
        name,
        userEndpointToken: primaryUserEndpointToken,
      };
    }

    const decodedJWT = await decodeJWT({
      apiKey: 'api_key' in jwt ? jwt.api_key : undefined,
      isEncrypted,
      token,
    });

    return {
      description,
      index,
      name,
      userEndpointToken: decodedJWT.workerTokenData?.userEndpointToken ?? '',
      partnerChains: decodedJWT.workerTokenData?.partnerChains ?? undefined,
    };
  });

  const decodedJwts = await Promise.all(promises);

  return decodedJwts;
};
